;(() => {
    const modal = document.querySelector('#modal-zoom-image')

    if (!modal) return

    const imageContainer = modal.querySelector('.modal-zoom-image__img')

    if (!imageContainer) return

    document.querySelectorAll('.js-zoom-images').forEach(container => {
        const images = container.querySelectorAll('[data-zoom]')
        images.forEach(image => {
            image.addEventListener('click', handleImageClick)
        })

        function handleImageClick() {
            console.log(this.src)
            imageContainer.src = this.src
            CNS.$fns.openZoomImage()
        }
    })
})()
